module.exports = __webpack_public_path__ + "img/p3_3.88bd84d2.png";